import React, { Component } from "react";

export default class NumKeyPad extends Component {
    render() {
        const buttonClick = this.props.buttonClick;

        return (
<div className="keypad">
    <div onClick={() => buttonClick("1")}>1</div>
    <div onClick={() => buttonClick("2")}>2</div>
    <div onClick={() => buttonClick("3")}>3</div>
    <div onClick={() => buttonClick("4")}>4</div>
    <div onClick={() => buttonClick("5")}>5</div>
    <div onClick={() => buttonClick("6")}>6</div>
    <div onClick={() => buttonClick("7")}>7</div>
    <div onClick={() => buttonClick("8")}>8</div>
    <div onClick={() => buttonClick("9")}>9</div>
    <div onClick={() => buttonClick("?")}>?</div>
</div>
            );
    }
}
